// src/stores/payrollOvertimeStore.js
import { defineStore } from "pinia";
import { ref } from "vue";
import PayrollOvertimeService from "@/services/payrollOvertime.service";
import { toast } from "@/utils/toast";

export const usePayrollOvertimeStore = defineStore("payrollOvertime", () => {
  // STATE
  const overtimeList = ref([]);
  const loading = ref(false);
  const isLoading = ref(false);
  const error = ref(null);

  // ACTIONS
  const fetchAll = async () => {
    loading.value = true;
    try {
      const res = await PayrollOvertimeService.getAll();
      overtimeList.value = res;
      error.value = null;
    } catch (e) {
      error.value =
        e?.response?.data?.message || "Failed to load overtime items";
    } finally {
      loading.value = false;
    }
  };

  const createOvertime = async (payload) => {
    isLoading.value = true;
    try {
      const response = await PayrollOvertimeService.create(payload);
      overtimeList.value.push(response.data);

      toast("Overtime created successfully!");
      return response.data;
    } catch (err) {
      error.value = err.response?.data?.message || "Failed to create overtime";
      toast(error.value, "error");
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  const updateOvertime = async (id, payload) => {
    isLoading.value = true;
    try {
      const response = await PayrollOvertimeService.update(id, payload);
      const index = overtimeList.value.findIndex((o) => o.id === id);

      if (index !== -1) {
        overtimeList.value[index] = response.data;
      }

      toast("Overtime updated successfully!");
      return response.data;
    } catch (err) {
      error.value = err.response?.data?.message || "Failed to update overtime";
      toast(error.value, "error");
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  const deleteOvertime = async (id) => {
    isLoading.value = true;
    try {
      await PayrollOvertimeService.delete(id);
      overtimeList.value = overtimeList.value.filter((o) => o.id !== id);
      toast("Overtime deleted successfully!");
    } catch (err) {
      error.value = err.response?.data?.message || "Failed to delete overtime";
      toast(error.value, "error");
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    overtimeList,
    loading,
    isLoading,
    error,
    fetchAll,
    createOvertime,
    updateOvertime,
    deleteOvertime,
  };
});
